import React, { useState } from "react";
import styled from "styled-components";
import { useCart } from "../context/CartContext";
import { createCheckoutSession, createVippsPayment } from "../utils/api";
import { FaUser, FaEnvelope, FaPhone, FaMobileAlt, FaTruck, FaMapMarkerAlt, FaCreditCard, FaPlus, FaMinus, FaTrash } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";


const Checkout = () => {
    const { 
        cartItems, 
        removeFromCart, 
        incrementItem, 
        decrementItem
    } = useCart();

    const [page, setPage] = useState(1);
    const navigate = useNavigate();

    const [customerInfo, setCustomerInfo] = useState({
        customerName: "",
        customerEmail: "",
        customerPhone: "",
        deliveryMethod: "pickup",
        customerAddress: { city: "Oslo", address: "", postalCode: "" },
        deliveryFee: 0,
        pickupLocation: "Ryen",
    });

    const totalOriginalPrice = cartItems.reduce((sum, item) => sum + item.quantity * item.price, 0);
    const totalDiscountedPrice = cartItems.reduce((sum, item) => sum + item.totalPrice, 0);
    const totalSavings = totalOriginalPrice - totalDiscountedPrice;

    const totalWithDelivery = (totalDiscountedPrice + customerInfo.deliveryFee).toFixed(0);

    

    const validateForm = () => {
        if (!customerInfo.customerName || !customerInfo.customerEmail || !customerInfo.customerPhone) {
            toast.error("Vennligst fyll inn alle feltene!");
            return false;
        }
    
        if (customerInfo.deliveryMethod === "delivery") {
            if (!customerInfo.customerAddress.address || !customerInfo.customerAddress.postalCode) {
                toast.error("Vennligst fyll inn alle adressefeltene!");
                return false;
            }
    
            if (totalDiscountedPrice < 249) {
                toast.error("Bestilling må være minst 249kr for å velge frakt!");
                return false;
            }
        }
    
        return true;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name in customerInfo.customerAddress) {
            setCustomerInfo((prev) => ({
                ...prev,
                customerAddress: { ...prev.customerAddress, [name]: value },
            }));
        } else {
            setCustomerInfo((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleCityChange = (e) => {
        const selectedCity = cities.find(city => city.name === e.target.value);
        const fee = selectedCity ? selectedCity.deliveryFee : 0;
    
        setCustomerInfo((prev) => ({
            ...prev,
            customerAddress: { ...prev.customerAddress, city: e.target.value },
            deliveryFee: fee,
        }));
    };

    const handlePhoneChange = (value) => {
        setCustomerInfo((prev) => ({ ...prev, customerPhone: value }));
    };

    const handleStripeCheckout = async () => {
        if (!validateForm()) return;

        try {
            const session = await createCheckoutSession({
                customerName: customerInfo.customerName,
                customerEmail: customerInfo.customerEmail,
                customerPhone: customerInfo.customerPhone,
                deliveryMethod: customerInfo.deliveryMethod,
                deliveryFee: customerInfo.deliveryFee,
                ...(customerInfo.deliveryMethod === "pickup"
                    ? { pickupLocation: customerInfo.pickupLocation }
                    : { customerAddress: customerInfo.customerAddress }),
                items: cartItems.map((item) => ({
                    productId: item._id,
                    name: item.name,
                    price: (item.totalPrice / item.quantity).toFixed(2),
                    quantity: item.quantity,
                    totalPrice: item.totalPrice
                })),
            });
            sessionStorage.setItem("paymentVerified", "true");
            window.location.href = session.url;
        } catch (error) {
            console.error("❌ Betalingsfeil:", error);
        }
    };

    const handleVippsCheckout = async () => {
        if (!validateForm()) return;

        try {
            const session = await createVippsPayment({
                customerName: customerInfo.customerName,
                customerEmail: customerInfo.customerEmail,
                customerPhone: customerInfo.customerPhone,
                deliveryMethod: customerInfo.deliveryMethod,
                deliveryFee: customerInfo.deliveryFee,
                pickupLocation: customerInfo.deliveryMethod === "pickup" ? customerInfo.pickupLocation : "",
                customerAddress: customerInfo.deliveryMethod === "delivery" ? customerInfo.customerAddress : "",
                items: cartItems.map((item) => ({
                    productId: item._id,
                    name: item.name,
                    price: (item.totalPrice / item.quantity).toFixed(2),
                    quantity: item.quantity,
                    totalPrice: item.totalPrice
                })),
            });
            sessionStorage.setItem("paymentVerified", "true");
            window.location.href = session.url;
        } catch (error) {
            console.error("❌ Feil ved Vipps-betaling:", error);
        }
    };

    const cities = [
        { name: "Oslo", deliveryFee: 0 },
        { name: "Lillestrøm", deliveryFee: 99 },
        { name: "Sandvika", deliveryFee: 99 },
        { name: "Lørenskog", deliveryFee: 49 },
    ];

    const calculateDeliveryFee = (distance) => {
        if (distance === 0) return 0;
        if (distance <= 20) return 49;
        if (distance <= 50) return 99;
        return 149;
    };

    

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    return (
        <Container>
            <ToastContainer position="top-right" autoClose={3000} />
            
            <CheckoutGrid>
                <LeftSide $page={page}>
                    <div className="page-wrapper">
                        <div className="page">

                            {page === 1 && (
                                <>
                                    <h2>Handlekurv</h2>
                                    {cartItems.length === 0 ? (
                                        <>
                                            <p>Handlekurven er tom.</p>
                                            <AddButton onClick={() => navigate("/shop")}>Legg Til Bær</AddButton>
                                        </>
                                    ) : (
                                        <CartList>
                                            {cartItems.map((item) => (
                                                <CartItem key={item._id}>
                                                    <ItemDetails>
                                                        <img src={item.image} alt={item.name} />
                                                        <div className="item-detail-content">
                                                            <div className="item-details">
                                                                <p className="item-title">{item.name}</p>
                                                                <p className="item-description">{item.description}</p>
                                                            </div>
                                                            <span className="item-qunatity-box">
                                                                <div className="box">
                                                                    <button>
                                                                        <FaMinus color="green" onClick={() => decrementItem(item._id)}/>
                                                                    </button>
                                                                    <input type="number" placeholder={item.quantity} />
                                                                    <button>
                                                                        <FaPlus color="green" onClick={() => incrementItem(item._id)}/>
                                                                    </button>
                                                                </div>
                                                                {/* <button className="item-remove">
                                                                    <FaTrash color="red" onClick={() => removeFromCart(item._id)}/>
                                                                </button> */}
                                                            </span>
                                                        </div>
                                                    </ItemDetails>
                                                    <p className="item-price-detail">{item.price} NOK</p>
                                                </CartItem>
                                            ))}
                                        </CartList>
                                    )}
                                </>
                            )}
                        </div>
                        
                        <div className="page">
                            {page === 2 && (
                                <>
                                    <BackArrow onClick={() => handlePageChange(page - 1)}/>
                                    <h2>Ordredetaljer</h2>

                                    <FormGroup>
                                        <Label><FaUser /> Navn</Label>
                                        <Input type="text" name="customerName" value={customerInfo.customerName} onChange={handleChange} required />
                                    </FormGroup>
                    
                                    <FormGroup>
                                        <Label><FaEnvelope /> E-post</Label>
                                        <Input type="email" name="customerEmail" value={customerInfo.customerEmail} onChange={handleChange} required />
                                    </FormGroup>
                    
                                    <FormGroup>
                                        <Label><FaPhone /> Telefon</Label>
                                        <PhoneInput
                                            country={"no"}
                                            value={customerInfo.customerPhone}
                                            onChange={handlePhoneChange}
                                            inputStyle={{ width: "100%", paddingBlock: "12px", height: "44px", borderRadius: "2px"}}
                                        />
                                    </FormGroup>
                    
                                    <FormGroup>
                                        <Label><FaTruck /> Leveringsmetode</Label>
                                        <Select name="deliveryMethod" value={customerInfo.deliveryMethod} onChange={handleChange}>
                                            <option value="pickup">Henting</option>
                                            <option value="delivery">Levering</option>
                                        </Select>
                                    </FormGroup>
                    
                                    {customerInfo.deliveryMethod === "pickup" && (
                                        <FormGroup>
                                            <Label><FaMapMarkerAlt /> Velg hentested</Label>
                                            <Select name="pickupLocation" value={customerInfo.pickupLocation} onChange={handleChange}>
                                                {["Ryen", "Storo", "Bryn Senter", "Majorstuen"].map((location) => (
                                                    <option key={location} value={location}>{location}</option>
                                                ))}
                                            </Select>
                                        </FormGroup>
                                    )}
                    
                                    {customerInfo.deliveryMethod === "delivery" && (
                                        <>
                                            <FormGroup>
                                                <Label>By</Label>
                                                <Select name="city" value={customerInfo.customerAddress.city} onChange={handleCityChange}>
                                                    {cities.map((city) => (
                                                        <option key={city.name} value={city.name}>
                                                            {city.name} {city.distance > 0 ? `(+${calculateDeliveryFee(city.distance)}kr)` : ""}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </FormGroup>
                    
                                            <FormGroup>
                                                <Label>Postnummer</Label>
                                                <Input type="number" name="postalCode" value={customerInfo.customerAddress.postalCode} onChange={handleChange} required />
                                            </FormGroup>
                    
                                            <FormGroup>
                                                <Label><FaMapMarkerAlt /> Adresse</Label>
                                                <Input type="text" name="address" value={customerInfo.customerAddress.address} onChange={handleChange} required />
                                            </FormGroup>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </LeftSide>

                <RightSide>
                    <div className="order-sumary-wrapper">
                        <h2>Ordre</h2>
                        
                        <div className="order-summary-detail">
                            <span>
                                <p className="label">Delsum</p>
                                <p className="price">{totalOriginalPrice.toFixed(0)} NOK</p>
                            </span>

                            

                            <span>
                                <p className="label">Frakt</p>
                                <p className="price">{customerInfo.deliveryFee === 0 ? "Gratis" : `${customerInfo.deliveryFee} NOK`}</p>
                            </span>
                            {totalSavings > 0 && (
                                <span>
                                    <p className="label">Rabatt</p>
                                    <p className="price" style={{ color: "#2d6a4f" }}>-{totalSavings.toFixed(0)} NOK</p>
                                </span>
                            )}
                        </div>
                        
                        <div className="order-summary-detail">
                            <span>
                                <p className="label">Totalt</p>
                                <p className="price">{totalWithDelivery} NOK</p>
                            </span>
                            <span>
                                <p className="label">Herav MVA</p>
                                <p className="price">{(totalDiscountedPrice * 0.15).toFixed(2)} NOK</p>
                            </span>
                        </div>
                        
                        {page === 1 && (
                            <CheckoutButton className="order-proceed-btn" onClick={() => handlePageChange(page + 1)} disabled={cartItems.length === 0}>
                                Fortsett Til Betaling
                            </CheckoutButton>
                        )}

                        {page === 2 && (
                            <PaymentButtons>
                                <CheckoutButton onClick={handleStripeCheckout}>
                                    <FaCreditCard /> Betal med Kort
                                </CheckoutButton>
                                <VippsButton onClick={handleVippsCheckout}>
                                    <FaMobileAlt /> Betal med Vipps
                                </VippsButton>
                            </PaymentButtons>
                        )}
                    </div>



                </RightSide>
            </CheckoutGrid>
        </Container>
    );
};

export default Checkout;

            

const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    min-height: 100vh;
    padding: 20px;
`;

const CheckoutGrid = styled.div`
    display: grid;
    row-gap: 32px;
    grid-template-columns: 100%;
    align-items: center;

    @media (min-width: 1024px){
        column-gap: 60px;
        grid-template-columns: auto 375px;
        row-gap: 0;
    }
`;



const RightSide = styled.aside`
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 2px;
    background: #fff;
    
    .label {
        font-size: .9em;
        font-weight: 300;
        
        @media (min-width: 768px){
            font-size: 1.1em;
        }
    }

    .price {
        font-size: 1em;
        font-weight: 500;

        @media (min-width: 768px){
            font-size: 1.2em;
        }
    }

    h2 {
        margin-bottom: 24px;
        font-size: 1.2em;

        @media (min-width: 768px) {
            margin-bottom: 40px;
            font-size: 1.5em;
        }
    }

    @media (min-width: 768px){
        padding: 32px;

    }
    .order-summary-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .order-summary-detail {
        display: flex;
        flex-direction: column;
        gap: 22px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 22px;
        margin-bottom: 24px;

        @media (min-width: 768px){
            padding-bottom: 28px;
            margin-bottom: 32px;
            
        }

        span {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .order-summary-total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        font-size: .9em;

        @media (min-width: 768px){
            margin-bottom: 28px;
            font-size: 1em;
        }

        .label {
            font-size: 1em;
            
            @media (min-width: 768px){
                font-size: 1.2em;
            }
        }
    
        .price {
            font-size: 1.1em;
    
            @media (min-width: 768px){
                font-size: 1.3em;
            }
        }
    }

    .order-proceed-btn {
        padding: 16px;
        width: 100%;
        text-align: center;
        font-size: .9em;
        border: none;
        background: #2d6a4f;
        color: #fff;
        font-weight: 700;
        text-transform: uppercase;
        cursor: pointer;

        @media (min-width: 768px){
            font-size: 1em;
        }
    }

`;

const LeftSide = styled.div`
    background: #ffffff;
    display: flex;
    padding: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    flex: 1;
    flex-direction: column;
    // position: relative;
    overflow: hidden;

    h2 {
        margin-top: 12px;
        margin-bottom: 24px;
    }

    .page-wrapper {
        display: flex;
        width: 200%;
        transform: ${({ $page }) => `translateX(${($page - 1) * -50}%)`}; 
        transition: transform 0.4s ease-in-out;
    }

    .page {
        width: 50%;
        flex-shrink: 0;
        position: relative;
    }
`;

const CartList = styled.div`
    max-height: 600px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const CartItem = styled.div`
    display: flex;
    align-items: flex-start;
    padding-bottom: 16px;
    padding-top: 16px;
    // flex-wrap: wrap;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    
    @media (min-width: 768px){
        padding-top: 32px;
        padding-bottom: 32px;
    }

    img {
        width: 100px;
        height: 100px;
        object-fit: contain;
        
        @media (min-width: 768px){
            width: 160px;
            height: 160px;
        }
    }

    .item-price-detail {
        font-size: 1.3rem;
        font-weight: 700;

        @media (max-width: 525px){
            font-size: .9rem;
            font-weight: 600;
        }
    }

`;

const ItemDetails = styled.div`
    display: flex;
    gap: 15px;
    max-width: 80%;

    .item-detail-content{
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item-details {
            @media (max-width: 425px){
                max-width: 80%;
            }

            .item-title {
                font-size: 1.1rem;
                @media (max-width: 525px) {
                    font-size: .9rem;
                }
            }
        }

        .item-description {
            font-size: .9rem;
            margin-top: 12px;

            @media (max-width: 768px){
                font-size: .7rem;
            }
        }

        
        .item-qunatity-box{
            display: flex;
            align-items: center;
            gap: 10px;

            button {
                padding: 15px 16px;
                border: none;
                background: none;
                font-size: 1rem;

                @media (max-width: 768px) {
                    padding: 8px 6px;
                    font-size: .7rem;
                }
            }

            @media (max-width: 768px){
                margin-top: 12px;
            }

            .box {
                background: #fff;
                border: 1px solid #8b8b8b;
                border-radius: 5px;
                display: flex;

                

                
                input {
                    padding: 15px 0px;
                    border: none;
                    width: 55px;
                    outline: none;
                    align-items: center;
                    text-align: center;
                    font-weight: 600;
                    font-size: 1.1rem;

                    &:focus{
                        border: none;
                    }

                    @media (max-width: 768px) {
                        padding: 8px 6px;
                        font-size: 1rem;
                    }

                }

            }
        }
    }

`;

const BackArrow = styled(FaArrowLeftLong)`
    position: absolute;
    top: -15px;
    left: -5px;
    cursor: pointer;
    color: #2d6a4f;
    font-size: 18px;
    z-index: 10;

    &:hover {
        color: #1b4332;
    }
`;


const FormGroup = styled.div`
    margin-bottom: 15px;
`;

const Label = styled.label`
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 5px;

    @media (max-width: 768px){
        font-size: .9rem;
    }
`;

const Input = styled.input`
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 2px;
    background: white;
    font-size: 1rem;

    &:focus {
        border-color: #2d6a4f;
        outline: none;
    }

    @media (max-width: 768px){
        font-size: .8rem;
    }
`;

const Select = styled.select`
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 2px;
    background: white;
    font-size: 1rem;

    &:focus {
        border-color: #2d6a4f;
        outline: none;
    }

    @media (max-width: 768px){
        font-size: .8rem;
    }
`;





const PaymentButtons = styled.div`
    margin-top: 16px;
    display: flex;
    width: 100%;
    gap: 10px;
    align-items: center;
    justify-content: center;
    

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;



const CheckoutButton = styled.button`
    background: #2d6a4f;
    color: white;
    padding: 12px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    width: 48%;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;

    &:hover {
        background: #1b4332;
    }

    &:disabled {
        background: #a0a0a0;
        cursor: not-allowed;
        opacity: 0.6;
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const AddButton = styled(CheckoutButton)`
    background: #b31a1a;
    transition: background 0.3s ease-in-out;
    margin-top: 1rem;
    width: auto;


    &:hover{
        background: #900;
    }
`;

const VippsButton = styled(CheckoutButton)`
    background: #ff5b24;

    &:hover {
        background: #d63f0f;
    }
`;